import { FC } from 'react';
import { SCUICollapsiblePaper } from '../../../../../atomic/molecules';
import { Grid } from '@mui/material';
import Swal from 'sweetalert2';

import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import './SCUIOFSDrawerContent.scss';

export const SCUIOFSDrawerContent: FC<{
    ofsLog: any;
    onClose?: any;
}> = ({ ofsLog, onClose }) => {
    const requestData = ofsLog && ofsLog.requestData;

    const { t } = useTranslation();

    function handleCopy(id: any) {
        let copyText = document.getElementById(id)?.innerText;
        if (copyText) {
            navigator.clipboard.writeText(copyText);
            Swal.fire({
                icon: 'success',
                title: t('general.copied'),
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }
    return (
        <Grid className="ofs-logs-drawer">
            <Grid className="ofs-logs-drawer-header" container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className="ofs-logs-drawer-title"
                    size={{
                        md: 11.5,
                        xs: 11.5,
                        lg: 11.5,
                    }}
                >
                    <h1 className="headtxt"></h1>
                </Grid>

                <Grid
                    className="ofs-logs-drawer-close"
                    size={{
                        md: 0.5,
                        xs: 0.5,
                        lg: 0.5,
                    }}
                >
                    <CloseIcon className="svg_icons ofs-logs-drawer-close-button" onClick={onClose} />
                </Grid>
            </Grid>
            <Grid className="ofs-logs-drawer-content" sx={{ margin: '2rem' }}>
                <SCUICollapsiblePaper
                    iconTooltip={t('general.copyToClipboard')}
                    icon={'fi-rr-copy'}
                    iconOnClick={() => handleCopy('requestData')}
                    paperText={'requestData'}
                    open={true}
                    withoutMargin
                    changeColorWhenOpen
                >
                    <pre id="requestData" className="jsonViewDiv">
                        {JSON.stringify(JSON.parse(requestData), null, 2)}
                    </pre>
                </SCUICollapsiblePaper>
            </Grid>
        </Grid>
    );
};
